import ApiPermisos from './../../services/apiPermisos'


export default {
  namespaced: true,
  // state,
  // actions,
  // mutations,
  // getters
  state: {
    errorMsj: '',
    loadingApproval: false,
  },
  getters: {},
  mutations: {
    setLoading: (state, loadingApproval) => {
      state.loadingApproval = loadingApproval;
    },
  },
  actions: {
    /*
     *
     * APPROVALS
     * 
     */
    //Guarda la aprobacion del tiquete
    actSaveTktApproval: async ({
      commit
    }, data) => {

      let id = data[0];
      let estado = data[1];
      commit('setLoading', true); // Start loading
      let response = await ApiPermisos.saveTktApproval(id,estado);
      commit('setLoading', false); // End loading
      commit('errorMsj', response);
      if (response.error) {
        return response.error;
      }
      else{
        return response;
      }
    },

    //Guarda el archivo del tiquete
    actSaveTktFile: async ({
      commit
    }, data) => {

      let id = data[0];
      let file = data[1];
      commit('setLoading', true); // Start loading
      let response = await ApiPermisos.saveTktFile(id,file);
      commit('setLoading', false); // End loading
      commit('errorMsj', response);
      if (response.error) {
        return response.error;
      }
      else{
        return response;
      }
    },

    //Guarda la aprobacion del Permiso
    actSaveApproval: async ({
      commit
    }, data) => {

      let id = data[0];
      let info = data[1];      
      commit('setLoading', true); // Start loading
      let response = await ApiPermisos.saveApproval(id,info);
      commit('setLoading', false); // End loading
      commit('errorMsj', response);      
      if (response.error) {
        return response.error;
      }
      else{
        return response;
      }
    },
  },
}